// @flow
const apiEndpoint = process.env.REACT_APP_MTM_API_ENDPOINT;
//const apiEndpoint = 'http://localhost:3099/api/v1';

const config = {
  RMRDigitalAPI: apiEndpoint
    ? apiEndpoint
    : '//mtmpostapi.roymorganuat.com/api/v1',
  productId: 1,
  sentryDSN: 'https://ccd39a8575f44156a63830bdc4adc785@sentry.io/219575',
  googleMapsApi: 'AIzaSyDFpiXwYP79_YAPu4Cpnl1H-Lrm36qIVrg', // here for reference only. Change manually in index.html
  uploadFolder: 'ShapeFileUploadsFromThePortal',
  mdsApiKey: 'Rb1Rb68Q8CM339jVEbqE6T74Ht39w8uJ1963iS13',
  emailVerificationPath: 'verify-email',
  setPasswordPath: 'reset-password',
  registrationPath: 'register'
};

export default config;



// WEBPACK FOOTER //
// ./src/config.js